export const getTotalDaysByCity = (assumptions) => {
    return Object.fromEntries(
        assumptions.map((assumption) => {
            const numsOnly = Object.fromEntries(
                Object.entries(assumption).filter(
                    ([key]) => !['label', 'total'].includes(key)
                )
            );
            return [
                assumption.label,
                Object.values(numsOnly).reduce((sum, num) => sum + num, 0),
            ];
        })
    );
};

export const getStyleClassForDate = (date, today, nearFuture) => {
    return date < today
        ? 'acquisitions-danger'
        : date < nearFuture
            ? 'acquisitions-warning'
            : 'acquisitions-good';
};

export const getCutOffDatesByCity = (totalDaysByCity, targets) => {
    const cutOffDates = {};
    const today = new Date();
    const today1Month = new Date();
    today1Month.setDate(today1Month.getDate() + 28);

    for (let city in totalDaysByCity) {
        const cityDates = {};
        Object.keys(targets).forEach((tgtDate) => {
            const cutOffDate = new Date(tgtDate);
            cutOffDate.setDate(cutOffDate.getDate() - totalDaysByCity[city]);
            cityDates[tgtDate] = {
                date: cutOffDate,
                status: getStyleClassForDate(cutOffDate, today, today1Month),
            };
        });
        cutOffDates[city] = cityDates;
    }
    return cutOffDates;
};
